define('OutSystems/ClientRuntime/modules/Database/WebSQL/Upgrader/WebSQLMetadataConverter',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertV2ToV0 = exports.convertV0ToV2 = void 0;
    function convertV0ToV2(record) {
        var v0ExtraInfo = JSON.parse(record.Extra_Info);
        var v2ExtraInfo = {
            v: 2,
            idIsAutoNumber: v0ExtraInfo.idIsAutoNumber,
            attrs: Object.keys(v0ExtraInfo.attrs).reduce(function (attrs, attr) {
                attrs[attr.toUpperCase()] = v0ExtraInfo.attrs[attr];
                return attrs;
            }, {}),
        };
        return {
            KEY: record.SS_Key,
            MODULEKEY: record.Module_SS_Key,
            UPGRADESTATUS: record.Upgrade_Status,
            NAME: record.Name,
            TABLENAME: record.Physical_Table_name,
            HASH: record.Hash,
            EXTRAINFO: JSON.stringify(v2ExtraInfo),
        };
    }
    exports.convertV0ToV2 = convertV0ToV2;
    function convertV2ToV0(record) {
        var v2ExtraInfo = JSON.parse(record.EXTRAINFO);
        var v0ExtraInfo = {
            v: 0,
            idIsAutoNumber: v2ExtraInfo.idIsAutoNumber,
            attrs: Object.keys(v2ExtraInfo.attrs).reduce(function (attrs, attr) {
                attrs[attr.toLowerCase()] = v2ExtraInfo.attrs[attr];
                return attrs;
            }, {}),
        };
        return {
            SS_Key: record.KEY,
            Module_SS_Key: record.MODULEKEY,
            Name: record.NAME,
            Physical_Table_name: record.TABLENAME,
            Hash: record.HASH,
            Extra_Info: JSON.stringify(v0ExtraInfo),
            Upgrade_Status: record.UPGRADESTATUS,
        };
    }
    exports.convertV2ToV0 = convertV2ToV0;
});
//# sourceMappingURL=WebSQLMetadataConverter.js.map;
